export default __webpack_public_path__ + "static/media/capital_section_image_desktop.fa05b54f.jpg";